export default function ContentContainer(props: {label: any, lang: string}) {

	if (!props.label) {
		return null
	}

	return (
		<div className="web-content" dangerouslySetInnerHTML={{__html: props.lang === 'en' ? props.label[0] : props.label[1]}}></div>
	)
}
  